import { BehaviorSubject, Subscription } from 'common/barrels/rx';

export class Substream<TFull, TSub> extends BehaviorSubject<TSub> {
    private fullSubscription: Subscription;

    private propagating = false;

    constructor(
        private full: BehaviorSubject<TFull>,
        separate: (x: TFull) => TSub,
        private combine: (x: TFull, y: TSub) => TFull
    ) {
        super(separate(full.getValue()));

        this.fullSubscription = full
            .skip(1)
            .distinctUntilChanged()
            .filter(() => !this.propagating)
            .subscribe(f =>
            {
                const newSubValue = separate(f);
                if (newSubValue === this.getValue())
                    return;

                this.next(newSubValue);

            }, x => this.error(x), () => this.complete());
    }

    next(n: TSub) {
        const existing = this.getValue();

        super.next(n);

        if (n === existing)
            return;

        const newFullValue = this.combine(this.full.getValue(), n);
        this.propagating = true;
        this.full.next(newFullValue);
        this.propagating = false;
    }

    error(e) {
        this.full.error(e);
        super.error(e);
    }

    unsubscribe() {
        this.fullSubscription.unsubscribe();
        super.unsubscribe();
    }
}